import { useRouter } from "next/router";
import { FeaturePermission } from "@/__generated__/featurePermissions";
import { useUser } from "@/auth/useUser";

export const useMedspaId = () => {
  const {
    query: { medspaId },
  } = useRouter();
  const { medspa, hasAnyOfFeaturePermissions } = useUser();

  const isMdOrGfeReviewer = hasAnyOfFeaturePermissions([
    FeaturePermission.IS_MEDICAL_DIRECTOR,
    FeaturePermission.IS_GFE_REVIEWER,
  ]);

  // MD/GFE Reviewer can be assigned to many medspas,
  // so they can't rely on the user's medspa that they are currently logged it
  return isMdOrGfeReviewer ? (medspaId as string) : medspa;
};
